import { encodedStringParser, stringParser } from '../inboundParsers';
import { playerAvatarParser } from './utils/playerAvatarInboundUtils';
export const TOURNEY_SUMMARY_PAYLOAD_DEFINITION = {
    shouldSplitWithBraces: true,
    definitionParts: [
        { name: 'winnerName', parser: stringParser },
        { name: 'avatar', parser: playerAvatarParser },
        { name: 'summaryHtml', parser: encodedStringParser },
        { name: 'legacyFlashBgLabel', parser: stringParser },
        { name: 'title', parser: encodedStringParser },
        { name: 'legacyIconLabel', parser: encodedStringParser },
        { name: 'shareWinMessage', parser: encodedStringParser }
    ]
};
